import React from 'react'
import { CallToAction } from 'components/CallToAction'

export const GDPRForm = () => (
    <>
        <br />
        <p className="relative z-10 mb-0 px-4 text-center text-sm font-bold md:text-lg">
            Need propertymanagement hosted in the EU?
        </p>
        <div className="flex flex-col items-center justify-center gap-2 md:flex-row xl:gap-4">
            <CallToAction width="106" to="https://app.icloud-ready.com/register">
                Try iCloudReady Cloud EU for free
            </CallToAction>
        </div>
        <br />
    </>
)
